import React from 'react';
import { Box, Container, useMediaQuery, useTheme } from '@mui/material';
import circleBack1 from '@assets/images/CirclesSvg/Circles1.svg';
import circleBack2 from '@assets/images/CirclesSvg/Circles3.svg';
import circleBack3 from '@assets/images/CirclesSvg/Circles2.svg';
import { useAsociadoStore } from '@store/useAsociadoStore';
import { makeStyles } from '@mui/styles';
import FormValidarUsuario from '@components/ValidarUsuario/FormValidarUsuario';
import OTP from '@components/ValidarUsuario/OTP';

const useStyles = makeStyles({
  root: {
    background: '#f5f5f5',
    paddingBottom: '90px',
  },
});

const ValidarUsuario = () => {
  const { breakpoints } = useTheme();
  const isTablet = useMediaQuery(breakpoints.down('md'));
  const classes = useStyles();
  const { verificado } = useAsociadoStore();

  return (
    <>
      <div className={classes.root}>
        <Box
          component={'img'}
          src={circleBack1}
          sx={{
            width: '42%',
          }}
          position={'absolute'}
          top={-50}
          left={0}
          alt={'Circle Background'}
        />
        <Box
          component={'img'}
          src={circleBack2}
          right={400}
          sx={{
            width: '35%',
          }}
          position={'absolute'}
          top={120}
          alt={'Circle Background'}
        />
        <Box
          component={'img'}
          src={circleBack3}
          left={500}
          sx={{
            width: '20%',
          }}
          position={'absolute'}
          zIndex={0}
          top={690}
          alt={'Circle Background'}
        />
        <Container maxWidth={'lg'}>
          <Box
            sx={{ flexGrow: 1 }}
            style={{
              marginTop: isTablet ? 140 : 100,
              minHeight: '70vh',
              position: 'relative',
            }}
            textAlign="center"
          >
            {verificado ? <OTP /> : <FormValidarUsuario />}

          </Box>
        </Container>
      </div>
    </>
  );
};
export default ValidarUsuario;
